import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const ConsultaChart = ({ selectedTimeRange, handleTimeRangeChange }) => {
  return (
    <Box>
      <FormControl variant="outlined" style={{ minWidth: 180 }}>
        <InputLabel>Rango de tiempo</InputLabel>
        <Select
          value={selectedTimeRange} // Estado del rango seleccionado
          onChange={handleTimeRangeChange} // Función para manejar los cambios en el selector
          label="Rango de tiempo"
        >
          <MenuItem value="dia">Día</MenuItem>
          <MenuItem value="mes">Mes</MenuItem>
          <MenuItem value="año">Año</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default ConsultaChart;
